<template>
    <div class="useMedicine-container">
        <div class="sect-container">
            <div class="form-container" >
                <template v-if="!isSubmit">
                    <p class="title">{{pageType == 1? $t("useMedicine.buyMedicineInfo"):pageType == 2?$t("useMedicine.medicineAdjustment"):pageType == 3?$t("useMedicine.drugWithdrawal"):''}}</p>
                    <p class="subtilte">{{$t("useMedicine.pleaseInputInfo")}}</p>
                    <div class="buy-form" v-if="pageType == 1">
                        <div class="form-item flexC">
                            <span class="label">{{$t("useMedicine.medicineName")}}：</span>
                            <span class="value">{{medicineName}}</span>
                        </div>
                        <div class="form-item flexC">
                            <span class="label">{{$t("useMedicine.buyMedicineTime")}}：</span>
                            <span class="value" @click="selectDate">{{buyDate}}</span>
                            <van-icon name="arrow" />
                        </div>
                        <div class="form-item flexC">
                            <span class="label">{{$t("useMedicine.buyMedicineNum")}}：</span>
                            <p class="value">
                                <van-field v-model="buyNum" type="number" placeholder="请输入" />
                            </p>
                            <span class="unit">{{medicineUnit||'盒'}}</span>
                        </div>
                    </div>
                    <div class="buy-form" v-if="pageType == 2">
                        <div class="form-item flexC">
                            <span class="label">调整后用药频率：</span>
                            <div class="value flexC">
                                <div class="item-value flexC">
                                    <span class="label">早</span>
                                    <van-field class="adjust" v-model="adjustDoseAm" type="number" placeholder="请输入" />
                                </div>
                                <div class="item-value flexC">
                                    <span class="label">晚</span>
                                    <van-field class="adjust" v-model="adjustDosePm" type="number" placeholder="请输入" />
                                </div>
                            </div>
                        </div>
                        <div class="form-item flexC selectOption-item">
                            <p class="label">调整原因<span>（多选）</span>：</p>
                            <div class="value ">
                                <!-- YYSelectOption -->
                                <div class="option-container" >
                                    <div class="option-item flexC" :class="{'activeItem':item.isSelected == 1}" v-for="(item,index) in YYSelectOption" :key="index" @click="item.isSelected == 1?item.isSelected=0:item.isSelected=1">
                                        <i class="icon"></i>
                                        <p class="name">{{item.text}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="buy-form" v-if="pageType == 3">
                        <div class="form-item flexC selectOption-item">
                            <p class="label">停药原因<span>（多选）</span>：</p>
                            <div class="value ">
                                <!-- YYSelectOption -->
                                <div class="option-container" >
                                    <div class="option-item flexC" :class="{'activeItem':item.isSelected == 1}" v-for="(item,index) in TYSelectOption" :key="index" @click="item.isSelected == 1?item.isSelected=0:item.isSelected=1">
                                        <i class="icon"></i>
                                        <p class="name">{{item.text}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="remarks-reason" v-if="otherResonShow">
                            <van-field v-model="remarksReason" ows="1" autosize type="textarea" placeholder="请填写原因（其他）" />
                        </div>
                    </div>
                </template>
                <div class="submit-container flexC" v-else>
                    <img src="@/assets/img/hosp-subscribe-success-icon.png" alt="">
                    <p class="text">已提交！</p>
                </div>
            </div>
            <div class="page-btn-container flexC" v-if="!isSubmit">
                <div class="btn-item flexC" @click="back">
                    上一步
                </div>
                <div class="btn-item flexC" @click="submitFun">
                    提交
                </div>
            </div>
        </div>
        <van-overlay v-show="DateShow" class-name="picketDate">
            <div class="null" @click="DateShow=false"></div>
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                :title='$t("useMedicine.selectBuyTime")'
                :min-date="minDate"
                @confirm="dateConfirm"
                @cancel="DateShow=false"
                :max-date="maxDate"
                
            />
        </van-overlay>
    </div>
</template>

<script>
import { medicationHengruiOptsGet, medicationHengruiStopMed, medicationHengruiBuyMedSubmit, medicationHengruiAdjust }  from "@/api/user"
import { getLocalDateTime } from "@/utils/date";
export default {
    data () {
        return {
            medicineName:"",
            medicineUnit:"",
            adjustDoseAm:"",
            adjustDosePm:"",
            buyNum:"",
            buyDate:getLocalDateTime(new Date()),
            DateShow:false,
            currentDate:new Date(),
            minDate:new Date(2010,0,1),
            maxDate:new Date(),
            getLocalDateTime,
            YYSelectOption:[],
            TYSelectOption:[],
            isSubmit:false,
            pageType:this.$route.query.type || 1,
            remarksReason:""
        }
    },
    computed: {
        otherResonShow(){
            let type = false;
            for (let i = 0; i < this.TYSelectOption.length; i++) {
                const it = this.TYSelectOption[i];
                if(it.text == '其他'&&it.isSelected == 1){
                    type = true
                }
            }
            return type
        }
    },
    created () {
        document.title = this.$t("useMedicine.name");
        this.getUseMedicineInfo()
    },
    methods: {
        back(){
            this.$router.go(-1)
        },
        // 提交
        async submitFun(){
            let result, toast;
            if(this.pageType == 1){
                if(!this.buyNum){
                    this.$toast(this.$t("useMedicine.pleaseBuyNum"))
                    return false;
                }
                toast = this.$Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: this.$t("message.loadingTxt")
                });	
                medicationHengruiBuyMedSubmit({
                    ...this.$route.query,
                    buyDate:this.buyDate,
                    buyNum:this.buyNum
                }).then(res =>{
                    toast.clear()
                    if(res.data.errorCode == 0){
                        this.isSubmit = !this.isSubmit;
                    }else{
                        this.$toast(res.data.errorMsg)
                    }
                });
            }
            if(this.pageType == 2){
                if(!this.adjustDoseAm){
                    this.$toast(this.$t("useMedicine.pleaseinputMiring"))
                    return false;
                }
                if(!this.adjustDosePm){
                    this.$toast(this.$t("useMedicine.pleaseinputEvening"))
                    return false;
                }
                let type = false,str="";
                for (let j = 0; j < this.YYSelectOption.length; j++) {
                    const jt = this.YYSelectOption[j];
                    if(jt.isSelected == 1){
                        type = true;
                        str = str + jt.text +',' 
                    }
                }
                if(!type){
                    this.$toast(this.$t("useMedicine.pleaseAdjustReason"))
                    return false;
                }
                toast = this.$Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: this.$t("message.loadingTxt")
                });	
                medicationHengruiAdjust({
                    ...this.$route.query,
                    adjustDoseAm:this.adjustDoseAm,
                    adjustDosePm:this.adjustDosePm,
                    remark:str
                }).then(res =>{
                    toast.clear()
                    if(res.data.errorCode == 0){
                        this.isSubmit = !this.isSubmit;
                    }else{
                        this.$toast(res.data.errorMsg)
                    }
                })
            }
            if(this.pageType == 3){
                let type = false,str="";
                for (let j = 0; j < this.TYSelectOption.length; j++) {
                    const jt = this.TYSelectOption[j];
                    if(jt.isSelected == 1){
                        type = true;
                        str = str + jt.text +',' 
                    }
                }
                if(!type){
                    this.$toast(this.$t("useMedicine.pleaseStopMedicineReason"))
                    return false;
                }
                toast = this.$Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: this.$t("message.loadingTxt")
                });	
                medicationHengruiStopMed({
                    ...this.$route.query,
                    remark: this.otherResonShow&&this.remarksReason?str+this.remarksReason:str
                }).then(res =>{
                    toast.clear()
                    if(res.data.errorCode == 0){
                        this.isSubmit = !this.isSubmit;
                    }else{
                        this.$toast(res.data.errorMsg)
                    }
                })
            }
        },
        getUseMedicineInfo(){
            const toast = this.$Toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: this.$t("message.loadingTxt")
			});	
            medicationHengruiOptsGet(this.$route.query).then(result =>{
                toast.clear();
                console.log(result);
                if(result.data.errorCode == 0){
                    this.medicineName = result.data.data.medName;
                    this.medicineUnit = result.data.data.medUnit;
                    for (let i = 0; i < result.data.data.medOpts.length; i++) {
                        const it = result.data.data.medOpts[i];
                        let arr = [];
                        for (let g = 0; g < it.opts.length; g++) {
                            const gt = {
                                text:it.opts[g],
                                isSelected:0
                            };
                            arr.push(gt)
                        }
                        if(it.type == 'tingYao'){
                            this.TYSelectOption = arr;
                        }
                        if(it.type == 'tiaoZheng'){
                            this.YYSelectOption = arr;
                        }
                    }
                }
            })
        },
        // 选择购药时间
        selectDate(){
            this.currentDate = new Date(this.buyDate);
            this.DateShow = true;
        },
        dateConfirm(){
            this.buyDate = getLocalDateTime(this.currentDate);
            this.DateShow = false;
        }
    }
}
</script>
<style lang="less" scoped>
.useMedicine-container{
    padding: 0 0.6rem;
    background: linear-gradient(360deg, #F2FBFF 0%, #76BDFF 100%);
    .sect-container{
        height: 100vh;
        width: 100%;
        overflow: auto;
        background: url("~@/assets/img/useMedicine-bg.png") no-repeat;
        background-size: 5.08rem 4.2rem;
        background-position: top right;
        background-repeat: no-repeat;
        .form-container{
            margin: 1.4rem auto 0.6rem auto;
            padding: 0.9rem 0.6rem;
            background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
            border-radius: 0.3rem;
            border: 0.04rem solid;
            border-image: linear-gradient(90deg, rgba(235, 247, 255, 1), rgba(255, 255, 255, 1));
            .title{
                font-size: 0.84rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #303133;
                line-height: 1.2rem;
            }
            .subtilte{
                font-size: 0.64rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: .9rem;
            }
            .buy-form{
                margin-bottom: 0.4rem;
                .form-item{
                    height: 2rem;
                    border-bottom: 0.04rem solid #F5F6FA;
                    .label{
                        font-size: 0.64rem;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 600;
                        flex: 0 0 auto;
                        margin-right: 0.2rem;
                        color: #333333;
                        &>span{
                            font-size: 0.52rem;
                        }
                    }
                    .value,.unit,.van-field{
                        text-align: right;
                        flex: 1;
                        font-size: 0.64rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    
                    .unit{
                        flex: 0 0 auto;
                    }
                    .van-icon-arrow{
                        flex: 0 0 auto;
                        margin-left: 0.2rem;
                        font-size: 0.6rem;
                    }
                    /deep/ .van-field{
                        padding-left: 0;
                        .van-field__control{
                            text-align: right;
                        }
                    }
                    /deep/ .adjust{
                        .van-field__control{
                            text-align: left;
                        }
                    }
                }
                .selectOption-item{
                    height: unset;
                    padding: 0.6rem 0;
                    align-items: flex-start;
                    .value{
                        text-align: unset;
                        .option-container{
                            .option-item{
                                font-size: 0.64rem;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #333333;
                                line-height: 0.9rem;
                                margin-bottom: 0.2rem;
                                align-items: flex-start;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                .icon{
                                    flex: 0 0 auto;
                                    margin-top: 0.23rem;
                                    margin-right: 0.24rem;
                                    width: 0.5rem;
                                    height: 0.5rem;
                                    border-radius: 50%;
                                    background: #BFBFBF;
                                    box-sizing: border-box;
                                    position: relative;
                                    &::after{
                                        position: absolute;
                                        width: 0.25rem;
                                        height: 0.25rem;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%,-50%);
                                        background: #FFFFFF;
                                        border-radius: 50%;
                                        content: ' ';
                                    }
                                }
                                .name{
                                    flex: 1;
                                    white-space:pre-wrap;
                                }
                            }
                            .activeItem{
                                .icon{
                                    background: #3387FD;
                                }
                            }
                        }
                    }
                }
                .remarks-reason{
                    background: #F5F6FA;
                    border-radius: 0.08rem;
                    padding: 0.25rem 0.4rem;
                    /deep/ .van-field__control{
                        font-size: 0.56rem;
                        color: #000;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        line-height: 0.8rem;
                        // height: unset !important;
                        &::placeholder{
                            color: #606266;
                        }
                    }
                    *{
                        background: none;
                        padding: 0;
                        margin: 0;
                    }
                }
            }
            .submit-container{
                width: 100%;
                margin: 1.3rem 0;
                flex-direction: column;
                justify-content: center;
                img{
                    width: 5.12rem;
                    height: 4.86rem;
                }
                .text{
                    font-size: 0.84rem;
                    margin-top: 0.72em;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #303133;
                }
            }
        }
        .page-btn-container{
            .btn-item{
                flex: 1;
                height: 1.76rem;
                background: #FFFFFF;
                border-radius: 1rem;
                border: 0.02rem solid #49A7FF;
                font-size: 0.76rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                justify-content: center;
                color: #49A7FF;
                &:last-child{
                    margin-left: 0.8rem;
                    color: #FFFFFF;
                    background: linear-gradient(180deg, #49BFFF 0%, #499FFF 100%);
                }
            }
        }
    }
}
.picketDate{
    display: flex;
    flex-direction: column;
    .null{
        flex: 1;
    }
    .van-picker {
        flex: auto 0 0;
    }
}
</style>